import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Stack, TextField, Collapse, Alert, Typography } from '@mui/material';

OneTimePassword.propTypes = {
    onChange: PropTypes.func.isRequired,
    error: PropTypes.bool,
    helperText: PropTypes.string,
};

export default function OneTimePassword({ onChange, error, helperText }) {
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const inputRefs = useRef([]);

    const handleChange = (e, index) => {
        const value = e.target.value;
        if (/^[0-9]$/.test(value) || value === '') {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);
            onChange(newOtp.join(''));

            // Move to next input
            if (value !== '' && index < 5) {
                inputRefs.current[index + 1].focus();
            }
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && otp[index] === '') {
            if (index > 0) {
                inputRefs.current[index - 1].focus();
            }
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData('text').slice(0, 6);
        if (/^\d{6}$/.test(pasteData)) {
            const newOtp = pasteData.split('');
            setOtp(newOtp);
            onChange(newOtp.join(''));
            inputRefs.current[5].focus();
        }
    };

    return (
        <>
            <Typography variant="h6">Please enter the code from your authenticator app</Typography>
            <br />
            <Stack direction="row" spacing={2} sx={{ margin: '20px 0' }} onPaste={handlePaste}>
                {otp.map((value, index) => (
                    <TextField
                        key={index}
                        inputRef={(el) => (inputRefs.current[index] = el)}
                        value={value}
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        inputProps={{
                            maxLength: 1,
                            style: { textAlign: 'center' },
                        }}
                        sx={{
                            width: '40px',
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#ccc',
                                },
                                '&:hover fieldset': {
                                    borderColor: 'primary.main',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: 'primary.main',
                                    boxShadow: `0 0 0 2px primary.light`,
                                },
                            },
                        }}
                    />
                ))}
            </Stack>
            <Collapse in={!!helperText}>
                <Alert severity="error" sx={{ mb: 2 }}>
                    {helperText}
                </Alert>
            </Collapse>
        </>
    );
}
